import type { Location } from "react-router-dom";

import type { ReminderShillUpsellAttributionContext } from "@/modules/reminder-shill-upsell-attribution";
import { subscriptionModule } from "@/modules/subscriptions";
import {
  StripeCheckoutContext,
  type StripeCheckoutOnboardingStep,
  type StripeCheckoutSource,
} from "@/modules/subscriptions/query-params";
import { BillingStrategyEnum } from "@/store/pages/SettingsSubscriptionManagementPageStore/types";
import type { AppStore } from "@/store/AppStore";
import { SubscriptionPlanKind, SubscriptionPlanVariant } from "@/store/subscriptions/types";

export async function startProactiveCheckout({
  location,
  reminderShillUpsellAttributionContext,
  checkoutOnboardingStep,
  checkoutSource,
  store,
}: {
  checkoutOnboardingStep?: StripeCheckoutOnboardingStep;
  checkoutSource?: StripeCheckoutSource;
  location: Location;
  reminderShillUpsellAttributionContext?: ReminderShillUpsellAttributionContext | null;
  store: AppStore;
}) {
  return subscriptionModule.createCheckoutSessionAndNavigate({
    billingStrategy: BillingStrategyEnum.MONTHLY,
    checkoutContext: StripeCheckoutContext.Proactive,
    ...(checkoutOnboardingStep !== undefined ? { checkoutOnboardingStep } : {}),
    ...(checkoutSource ? { checkoutSource } : {}),
    location,
    planKind: SubscriptionPlanKind.PROACTIVE,
    planVariant: SubscriptionPlanVariant.STANDARD,
    reminderShillUpsellAttributionContext,
    store,
  });
}
